import React from "react";
import Alert from "react-bootstrap/Alert";

const Info = () => {
	return <Alert variant="info">Site is under construction</Alert>;
};

export default Info;
